import React from 'react'

class Alert extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        const { title, description, proceed, cancel, onSuccess, onFailure, textField, screen } = this.props
        const isFeedbackSuccess = screen === 'submittedFeedback'
        return (
            <React.Fragment>
                <div className="nurse-popup-overlay" role="dialog" aria-modal="true">
                    <div className="nurse-popup-card">
                        {(screen !== 'submittedFeedback' && screen !== 'feedback') && (
                            <button
                                type="button"
                                className="nurse-popup-close"
                                aria-label="Close"
                                onClick={() => onFailure()}
                            >
                                ×
                            </button>
                        )}
                        <form onSubmit={(e) => e.preventDefault()}>
                            {isFeedbackSuccess && (
                                <div className="text-center mb-3">
                                    <div className="call-status-avatar mx-auto" style={{ width: 72, height: 72, fontSize: '1.75rem' }}>
                                        <i className="fa-solid fa-check" aria-hidden="true"></i>
                                    </div>
                                </div>
                            )}
                            {title && <h3 className="nurse-popup-title">{title}</h3>}
                            {description && <p className="nurse-popup-desc">{description}</p>}
                            {textField && (
                                <div className="mb-3">
                                    <textarea className="form-control textarea-width" placeholder="Search by order no" />
                                </div>
                            )}
                            {!isFeedbackSuccess && (
                                <div className="nurse-popup-actions">
                                    <button
                                        type="button"
                                        className={`nurse-btn ${screen === 'feedback' ? 'nurse-btn-primary' : 'nurse-btn-primary'}`}
                                        onClick={() => onSuccess()}
                                    >
                                        {proceed}
                                    </button>
                                    <button
                                        type="button"
                                        className="nurse-btn nurse-btn-secondary"
                                        onClick={() => onFailure()}
                                    >
                                        {cancel}
                                    </button>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Alert;
